module.exports = __webpack_public_path__ + "img/kleisma3m-m@2.19bcfc6e.webp";